import React from 'react';
import {Link} from 'react-router-dom';
import { IMAGES } from '../constants/theme';
import { useLanguage } from '../i18n/LanguageContext';

const PageTitle = ({parentTitle, activePage}) => {
    const { t } = useLanguage();
    return (
        <>
            <div className="dz-bnr-inr style-1 text-center" data-text="FITNESS" style={{backgroundImage: "url("+IMAGES.BgBanner2 +")"}}>
                <div className="container">
                    <div className="dz-bnr-inr-entry">
                        <h1>{t(activePage)}</h1>
                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to={"/"}>{t(parentTitle)}</Link></li>{" "}
                                <li className="breadcrumb-item active" aria-current="page">{t(activePage)}</li>
                            </ul>
                        </nav>
                        
                    </div>
                </div>
            </div>
          
        </>
    );
};

export default PageTitle;
